import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ModalsComponent } from './views/modals/modals.component';
import { BasicTableComponent } from './views/tables/basic-table/basic-table.component';
import { NotFoundComponent } from './views/errors/not-found/not-found.component';
import { DashboardComponent } from './views/dashboards/dashboard/dashboard.component';
import { LoginComponent } from './views/login/login.component';
import { AuthService as AuthGuard } from './services/auth.service';
import { TermsOfServiceComponent } from './views/legal/terms-of-service/terms-of-service.component';
import { PrivacyPolicyComponent } from './views/legal/privacy-policy/privacy-policy.component';
import { ConfirmRegistrationComponent } from './views/login/confirm-registration/confirm-registration.component';
import { ConfirmPasswordResetComponent } from './views/login/confirm-password-reset/confirm-password-reset/confirm-password-reset.component';
import { PasswordResetComponent } from './views/login/password-reset/password-reset/password-reset.component';
import { TradePlanningComponent } from './views/transactions/trade-planning/trade-planning.component';
import { SettingsComponent } from './views/account/settings/settings.component';
import { FiaComponent } from './views/fia/fia/fia.component';
import { MarketTradesComponent } from './views/marketTrades/market-trades/market-trades.component';
import { UserManagementComponent } from './views/user-management/user-management.component';
import { TradesInProgressComponent } from './views/transactions/trades-in-progress/trades-in-progress.component';
import { ToolsComponent } from './views/tools/tools.component';
import { HelpComponent } from './views/help/help.component';
import { WorkbenchComponent } from './views/tools/workbench/workbench.component';
import { PublicHolidaysComponent } from './views/tools/public-holidays/public-holidays.component';
import { AitComponent } from './views/ait/ait.component';
import { OnboardingComponent } from './views/onboarding/onboarding.component';
import { WealthOnboardingComponent } from './views/wealth-onboarding/wealth-onboarding.component';
import { OffboardingComponent } from './views/offboarding/offboarding.component';
import { CurrentTradesComponent } from './views/transactions/current-trades/current-trades.component';
import { SqlReportsComponent } from './views/reports/sql-reports/sql-reports.component';
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 64],
};

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    data: { title: 'Login' },
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login' },
  },
  {
    path: 'resetpassword',
    component: PasswordResetComponent,
    data: { title: 'Reset Password' },
  },
  {
    path: 'resetpassword/confirm',
    component: ConfirmPasswordResetComponent,
    data: { title: 'Password Reset' },
  },
  {
    path: 'confirmations/register-confirm/:combinedKeys',
    component: ConfirmRegistrationComponent,
    data: { title: 'Confirm Registration' },
  },
  {
    path: 'confirmations/password-reset/:password-key',
    component: ConfirmPasswordResetComponent,
    data: { title: 'Password Reset' },
  },
  {
    path: 'termsofservice',
    component: TermsOfServiceComponent,
    data: { title: 'Terms Of Service' },
  },
  {
    path: 'privacypolicy',
    component: PrivacyPolicyComponent,
    data: { title: 'Privacy Policy' },
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: { title: 'Dashboard' },
    canActivate: [AuthGuard],
  },
  {
    path: 'fia',
    component: FiaComponent,
    data: { title: 'FIA' },
    canActivate: [AuthGuard],
  },
  {
    path: 'market-trades',
    component: MarketTradesComponent,
    data: { title: 'Market Trades' },
    canActivate: [AuthGuard],
  },
  {
    path: 'trade-planning',
    component: TradePlanningComponent,
    data: { title: 'Trade Planning' },
    canActivate: [AuthGuard],
  },
  {
    path: 'current-trades',
    component: CurrentTradesComponent,
    data: { title: 'Current Trades' },
    canActivate: [AuthGuard],
  },
  {
    path: 'trade-docs',
    component: TradesInProgressComponent,
    data: { title: 'Trade Docs' },
    canActivate: [AuthGuard],
  },
  {
    path: 'tools',
    component: ToolsComponent,
    data: { title: 'Tools' },
    canActivate: [AuthGuard],
  },
  {
    path: 'tools/workbench',
    component: WorkbenchComponent,
    data: { title: 'Workbench' },
    canActivate: [AuthGuard],
  },
  {
    path: 'tools/public-holidays',
    component: PublicHolidaysComponent,
    data: { title: 'Public Holidays' },
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    component: SettingsComponent,
    data: { title: 'Settings' },
    canActivate: [AuthGuard],
  },
  {
    path: 'user-management',
    component: UserManagementComponent,
    data: { title: 'User Management' },
    canActivate: [AuthGuard],
  },
  {
    path: 'help',
    component: HelpComponent,
    data: { title: 'My Help' },
    canActivate: [AuthGuard],
  },
  {
    path: 'ait',
    component: AitComponent,
    data: { title: 'AIT Management' },
    canActivate: [AuthGuard],
  },
  {
    path: 'onboarding',
    component: OnboardingComponent,
    data: { title: 'Onboarding' },
    canActivate: [AuthGuard],
  },
  {
    path: 'wealth-onboarding',
    component: WealthOnboardingComponent,
    data: { title: 'Wealth Onboarding' },
    canActivate: [AuthGuard],
  },
  {
    path: 'offboarding',
    component: OffboardingComponent,
    data: { title: 'Offboarding' },
    canActivate: [AuthGuard],
  },
  {
    path: 'sql-reports',
    component: SqlReportsComponent,
    data: { title: 'Reporting' },
    canActivate: [AuthGuard],
  },
  {
    path: 'tables',
    children: [{ path: 'table1', component: BasicTableComponent }],
    canActivate: [AuthGuard],
  },
  { path: 'modals', component: ModalsComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
